import clsx from "clsx";
import { InnerBlocks } from "@wordpress/block-editor";

export default function Save({ attributes }) {
  const {
    popupBackdropColor = "#00000033",
    popupBackgroundColor = "",
    popupBoder = {},
    popupShadow = "",
    popupPadding = {},
  } = attributes?.style ?? {};
  const blockAlignment = attributes?.blockAlignment ?? "";

  return (
    <div
      className={clsx(
        "brandy-quick-view-product-block",
        blockAlignment ? `has-block-alignment-${blockAlignment}` : ""
      )}
      data-backdrop-color={popupBackdropColor}
      data-background-color={
        popupBackgroundColor || "var(--wp--custom--background)"
      }
      data-border-width={popupBoder.width || "0px"}
      data-border-style={popupBoder.style || "solid"}
      data-border-color={popupBoder.color || "#000000"}
      data-border-radius={popupBoder.radius || "10px"}
      data-padding-top={popupPadding.top || "30px"}
      data-padding-right={popupPadding.right || "30px"}
      data-padding-bottom={popupPadding.bottom || "30px"}
      data-padding-left={popupPadding.left || "30px"}
      data-box-shadow={popupShadow || ""}
    >
      <InnerBlocks.Content />
    </div>
  );
}
